import { HallandaleInterface } from '../interfaces';
import { createTableColumns } from '../utils';

import Axios from "../libraries/axios";

class HallandaleModel implements HallandaleInterface {
	[key: string]: any
	internalPatientId = '';
	payload = {};

	constructor(props: HallandaleInterface) {
	  if (props) {
	    Object.assign(this, props);
	  }
	}

	static getColumns() {
	  return createTableColumns(['patientEmail', 'addressDetails', 'trackingNumber', 'createdAt']);
	}

	static async fetchAll<ReturnType>(
	  params: any = {},
	  config: any = {}
	): Promise<ReturnType> {
	  try {
	    const { data } = await Axios.get('/api/hallandale', {
	      params,
	      ...config,
	    });

	    data.data.map((item: any) => {
	      item.patientEmail = item.payload[0].patientEmail;
	      item.trackingNumber = item.payload[0].trackingNumber;
	      item.addressDetails = `${item.payload[0].shipAddressLine1} ${item.payload[0].shipCity} ${item.payload[0].shipState} ${item.payload[0].shipZip}`;
	      return item;
	    });

	    return data;
	  } catch (e: any) {
	    throw new Error(e);
	  }
	}
}

export default HallandaleModel;
